var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"bottom_nav"},[_c('div',{staticClass:"item"},[_vm._v(" "+_vm._s(_vm.pageTitle)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }